import { CONTAINER_PARTS } from './containerParts';
import type { ContainerStyleConfig } from './types';

export const CONTAINER_STYLE_CONFIG: ContainerStyleConfig = {
  parts: CONTAINER_PARTS,
  baseStyle: {
    container: {
      display: 'flex',
      flexDirection: 'column',
      background: 'page.surface',
      overflow: 'hidden',
    },
    containerHeader: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
      flex: '0 0 auto',
      borderBottom: '1px solid',
      borderColor: 'separator.divider',
    },
    containerTitle: {
      fontWeight: 'heavy',
    },
    containerBody: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
    },
    containerFooter: {
      paddingX: 1.5,
      background: 'page.surface',
      display: 'flex',
      flex: '0 0 auto',
      borderTop: '1px solid',
      borderColor: 'separator.divider',
    },
  },
  variants: {
    default: {
      container: {
        border: '1px solid',
        borderColor: 'separator.border',
        borderRadius: 'lg',
      },
      containerHeader: {
        borderTopRadius: 'lg',
      },
      containerFooter: {
        borderBottomRadius: 'lg',
      },
    },
    borderless: {
      container: {
        border: 'none',
      },
      containerHeader: {
        borderTopRadius: 'none',
      },
      containerFooter: {
        borderBottomRadius: 'none',
      },
    },
  },
  sizes: {
    sm: {
      containerHeader: {
        paddingY: 1,
      },
      containerTitle: {
        fontSize: 'sm',
        lineHeight: 'sm',
      },
      containerBody: {
        paddingY: 1,
      },
      containerFooter: {
        paddingY: 1,
      },
    },
    md: {
      containerHeader: {
        paddingY: 1.25,
      },
      containerTitle: {
        fontSize: 'md',
        lineHeight: 'md',
      },
      containerBody: {
        paddingY: 1.25,
      },
      containerFooter: {
        paddingY: 1.25,
      },
    },
    lg: {
      containerHeader: {
        paddingY: 1.5,
      },
      containerTitle: {
        fontSize: 'lg',
        lineHeight: 'lg',
      },
      containerBody: {
        paddingY: 1.5,
      },
      containerFooter: {
        paddingY: 1.5,
      },
    },
  },
  defaultProps: {
    size: 'md',
    variant: 'default',
  },
};
